<template>
  <div class="question-wrap">
    <div class="timer">
      <!-- <img
        src="https://cbgccdn.thecover.cn/@/images/20210824/1629776832928047830.png"
        alt=""
      /> -->
      <span> {{ formattedTime }}</span>
    </div>

    <Swipe
      :show-indicators="false"
      :touchable="false"
      ref="swiper"
      class="wrap"
    >
      <SwipeItem v-for="(item, index) in questions" :key="index">
        <qusestionItem
          :question="item"
          :index="index"
          :max-length="questions.length"
          v-on:finish="onFinish"
          v-on:next="goNext"
        ></qusestionItem>
      </SwipeItem>
    </Swipe>
  </div>
</template>

<script>
import { getQuestions } from "./questionList";
import qusestionItem from "./questionItem";
import { Swipe, SwipeItem } from "vant";
export default {
  components: { Swipe, SwipeItem, qusestionItem },
  data() {
    return {
      questions: [],
    };
  },
  created() {
    let arr = getQuestions(5);
    this.questions = [
      ...arr,
      {
        A: "非常满意 ",
        B: "满意",
        C: "基本满意",
        D: "不满意",
        answer: "ABCD",
        question:
          "您对您目前所在地的公共文化服务是否满意？（本题不计入积分、不参与排行）",
        type: 4,
      }
    ];
  },
  computed: {
    formattedTime() {
      let s = parseInt(this.time),
        h = 0,
        m = 0;

      if (s >= 60) {
        m = parseInt(s / 60);
        s = parseInt(s % 60);
        if (m > 60) {
          h = parseInt(m / 60);
          m = parseInt(m % 60);
        }
      }
      // 补零
      let zero = function (v) {
        return v >> 0 < 10 ? "0" + v : v;
      };
      return [zero(h), zero(m), zero(s)].join(":");
    },
  },
  props: ["time"],
  methods: {
    goNext(payload) {
      this.$refs["swiper"].next();
      this.$emit("record-result", payload);
    },
    onFinish(payload) {
      this.$emit("record-result", payload);
      this.$emit("finish",payload);
    },
  },
};
</script>

<style lang="scss" scoped>
.question-wrap {
}
.wrap {
  box-shadow: 5px 5px 0 0px rgba(255, 255, 255, 0.7);
  border-radius: 3px;
}
.van-swipe-item {
  background-color: #fff;

  padding: 20px;
  border: 1px solid #111;
  // border-radius: 5px;
  border-radius: 3px;
}
.timer {
  text-align: right;
  color: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
  img {
    width: 25px;
    margin-right: 5px;
  }
}
</style>